import React from 'react'
import classNames from 'classnames'
import { Image } from '@/atoms/Image'
import { AsFigCaption, AsH3, CaptionSM, TitleXS } from '@/atoms/Text'
import { ContentfulCloudinaryImageType } from '@/services/EmailCapturePageService/EmailCapturePageService'
import { buildCloudinaryImagePathFromContentfulObject } from '@/utils/Cloudinary/cloudinary'

interface RatingItemProps {
  icon?: ContentfulCloudinaryImageType | ContentfulCloudinaryImageType[]
  rating: string | undefined | null
  author: string | undefined | null
  size?: number
  className?: string
}

export const RatingItem: React.FC<RatingItemProps> = ({ icon, rating, author, className, size = 56 }) => {
  if (!icon) return null

  return (
    <figure
      className={classNames(
        'flex flex-col items-center md:justify-around md:flex-row m-4 gap-2 md:gap-4 min-w-[81px]',
        className,
      )}
    >
      <div className="mx-auto w-[56px]">
        <Image
          src={buildCloudinaryImagePathFromContentfulObject(icon)}
          width={size}
          height={size}
          alt={`${author} Rating`}
        />
      </div>
      <div className="text-center md:mx-auto md:ml-2 md:w-[60%] md:text-left">
        <TitleXS as={AsFigCaption} weight="bold" className="md:photon-title-lg my-1 md:mt-2">
          {rating}
        </TitleXS>
        <CaptionSM
          as={AsH3}
          weight="medium"
          color="core-gray-500"
          className="md:photon-caption-md lg:photon-caption-lg"
        >
          {author}
        </CaptionSM>
      </div>
    </figure>
  )
}
